import React from 'react';

export default function CameraIcon(props) {
    return (
        <svg width='28' height='28' viewBox='0 0 28 28' {...props}>
            <path
                fill='#1D1D1B'
                fillRule='evenodd'
                d='M9.3 9.94h7.242c.578 0 1.048.46 1.064 1.035v1.627l2.212-1.105a.532.532 0 0 1 .77.476v4.667a.532.532 0 0 1-.77.476l-2.212-1.106v1.598c0 .578-.46 1.048-1.035 1.064H9.301c-.579 0-1.05-.46-1.065-1.035V11.005c0-.578.46-1.049 1.034-1.064h7.272H9.3z'
            />
        </svg>
    );
}
